import { tdsFetch, jsonToQuery } from '@/utils/fetch';

const prefix = '/disclosure-framework';

export const fetchList = (data) => {
  return tdsFetch(`${prefix}${jsonToQuery(data)}`, { method: 'GET' })
}

export const fetchCreate = (data) => {
  return tdsFetch(prefix, { method: 'POST', body: data })
}

export const fetchUpdate = (data) => {
  return tdsFetch(prefix, { method: 'PUT', body: data })
}

export const fetchSort = (ids) => {
  return tdsFetch(`${prefix}/sort`, { method: 'PUT', body: { ids } })
}

export const fetchDelete = (ids) => {
  return tdsFetch(`${prefix}/batch-delete`, { method: 'DELETE', body: ids })
}
